export default "__VITE_ASSET__vLPKUAk8__"